/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Link_SlugInputs */

const vi_shop_home_link_slug = /** @type {(inputs: Shop_Home_Link_SlugInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đường dẫn`)
};

/**

* @param {Shop_Home_Link_SlugInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_link_slug = /** @type {((inputs?: Shop_Home_Link_SlugInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Link_SlugInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_link_slug(inputs)
});